import { Box, Grid2, Typography } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
// import { AiEdgeImages } from '../../assets/img/aiedge/AiEdgeImages'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const OurApproachSection = ({ approachesData }) => {
    const RenderPoints = ({ points, title }) => (
        <>
            <Typography variant='body1' fontWeight={600} dangerouslySetInnerHTML={{ __html: title }} />
            {points.map((txt) => (
                <Typography variant='body2' fontWeight={300} my={1} dangerouslySetInnerHTML={{ __html: txt }} />

            ))}
        </>
    )
    return (
        <Box>
            <Heading Heading={approachesData?.subheading} SubHeading={approachesData?.heading} />
            <CustomDivider />
            <Grid2 container spacing={"1rem"}>
                <Grid2 container size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: "flex", flexDirection: "column" }}>

                    <Grid2 children size={12}

                        sx={{
                            p: 2,
                            boxShadow: "0px 4px 4px 0px #00000040",
                            background: "primary.main",
                            border: "1px solid #D1D1D1",
                            borderRadius: 2,
                            flex: 3,

                        }}
                    >
                        {/* <Typography variant='body1' fontWeight={600}>Personalized Academic Path for Every Child</Typography>
                        <Typography variant='body2' fontWeight={300} my={1}>
                            No two students learn the same way. LATAA ensures each child receives the right concept at the right time, based on their readiness
                        </Typography> */}
                        <RenderPoints title={approachesData?.approaches[0]?.Title} points={approachesData?.approaches[0]?.approachesList} />
                        <Box

                            component={"img"}
                            // src={AiEdgeImages.ApproachFrame1}
                            src={getImageUrl(approachesData?.approaches[0]?.imageUrl)}
                            sx={{ height: 150, objectFit: "cover", width: "100%", borderRadius: 2 }}
                        />
                    </Grid2>
                    <Grid2 children size={12}

                        sx={{
                            p: 2,
                            boxShadow: " 0px 4px 4px 0px #00000040",
                            background: "#87CEEB",
                            borderRadius: 2,
                            flex: 6,

                        }}
                    >
                        <RenderPoints title={approachesData?.approaches[1]?.Title} points={approachesData?.approaches[1]?.approachesList} />
                        {/* <Typography variant='body1' fontWeight={600}>Stronger Basics, Faster Improvement</Typography>
                        <Typography variant='body2' fontWeight={300} my={1}>
                            By filling learning gaps and strengthening foundations, children gain confidence and perform better in schoo
                        </Typography> */}
                    </Grid2>


                </Grid2>
                <Grid2 container size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid2 children size={12}

                        sx={{
                            p: 2,
                            boxShadow: "0px 4px 4px 0px #00000040",
                            background: "#FAC584",
                            borderRadius: 2,
                            flex: 7,

                        }}
                    >
                        <RenderPoints title={approachesData?.approaches[2]?.Title} points={approachesData?.approaches[2]?.approachesList} />
                        {/* <Typography variant='body1' fontWeight={600}>Adaptive Learning That Grows With the Child</Typography>
                        <Typography variant='body2' fontWeight={300} my={1}>
                            As the student improves, LATAA adjusts difficulty levels, introduces higher concepts, and supports long-termacademic mastery
                        </Typography> */}
                    </Grid2>
                    <Grid2 children size={12}

                        sx={{
                            p: 2,
                            boxShadow: "0px 4px 4px 0px #00000040",
                            background: "#FAC584",
                            borderRadius: 2,
                            flex: 3,

                        }}
                    >
                        {/* <Typography variant='body1' fontWeight={600}>Teacher-Enabled, AI-Supported</Typography>
                        <Typography variant='body2' fontWeight={300} my={1}>
                            Educators get clear insights into each child’s progress, helping them guide learning more effectively
                        </Typography> */}
                        <RenderPoints title={approachesData?.approaches[3]?.Title} points={approachesData?.approaches[3]?.approachesList} />
                        <Box

                            component={"img"}
                            // src={AiEdgeImages.ApproachFrame2}
                            src={getImageUrl(approachesData?.approaches[3]?.imageUrl)}
                            sx={{ height: 150, objectFit: "cover", width: "100%", borderRadius: 2 }}
                        />
                    </Grid2>

                </Grid2>
                <Grid2 children size={{ xs: 12, sm: 12, md: 4 }}

                    sx={{
                        p: 2,
                        boxShadow: "0px 8px 16px 0px #00000040",
                        border: "1px solid #D8D8D8",
                        background: "primary.main",
                        borderRadius: 2

                    }}
                >
                    {/* <Typography variant='body1' fontWeight={600}>A Complete Development System</Typography>
                    <Typography variant='body2' fontWeight={300} my={1}>LATAA brings together</Typography>
                    <Typography variant='body2' fontWeight={300} my={1}>NCERT / Publisher-aligned curriculum</Typography>
                    <Typography variant='body2' fontWeight={300} my={1}>ELYF foundation-building</Typography>
                    <Typography variant='body2' fontWeight={300} my={1}>Skill-based practical exposure</Typography>
                    <Typography variant='body2' fontWeight={300} my={1}>Personalized academic reinforcement</Typography>
                    <Typography variant='body2' fontWeight={300} my={1}>This ensures a child is not only exam-ready but life-ready</Typography> */}
                    <RenderPoints title={approachesData?.approaches[4]?.Title} points={approachesData?.approaches[4]?.approachesList} />
                    <Box

                        component={"img"}
                        // src={AiEdgeImages.ApproachFrame3}
                        src={getImageUrl(approachesData?.approaches[4]?.imageUrl)}
                        sx={{ height: 200, objectFit: "cover", width: "100%", borderRadius: 2 }}
                    />
                </Grid2>

            </Grid2>
        </Box>
    )
}

export default OurApproachSection
